// @ts-nocheck
import PropTypes from "prop-types";
import { FileUpload } from "./FileUpload";
import { useDispatch } from "react-redux";
import { Box, FormControl, Grid, InputLabel, Typography } from "@mui/material";
import styles from "./../contractDetails.module.css";
import { CustomInput } from "../../../components/Custom/Input";
import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { SignatureDropdown } from "./SignatureDropdown";

export default function DigitalSignature({ setFields, addSignature }) {
  const inputValuesInit = useMemo(() => {
    return {
      fullName: "",
      initials: "",
    };
  }, []);
  const [inputValues, setInputValues] = useState(inputValuesInit);
  const dispatch = useDispatch();

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;

      const newData = { type: "Signature", text: dataUrl };

      addSignature(newData, dispatch);

      setFields((prev) =>
        prev.map((group) => {
          if (group.type === "Signature") {
            return {
              ...group,
              list: [
                ...group.list.slice(0, -1),
                newData,
                group.list[group.list.length - 1],
              ],
            };
          }
          return group;
        }),
      );
    };
    reader.readAsDataURL(file);
  };
  const handleSaveSignature = (signatureData) => {
    const newData = {
      type: "Signature",
      text: signatureData?.image,
    };

    addSignature(newData, dispatch);

    setFields((prev) =>
      prev.map((group) => {
        if (group.type === "Signature") {
          return {
            ...group,
            list: [
              ...group.list.slice(0, -1),
              newData,
              group.list[group.list.length - 1],
            ],
          };
        }
        return group;
      }),
    );
  };

  return (
    <Box className={styles["digital-container"]}>
      <Grid container>
        <Grid item xs={12}>
          <InputLabel>Full Name</InputLabel>
          <CustomInput
            fullWidth
            value={inputValues?.fullName}
            onChange={(e) =>
              setInputValues((prev) => ({
                ...prev,
                fullName: e?.target?.value,
              }))
            }
          />
        </Grid>
      </Grid>
      <SignatureDropdown
        fullName={inputValues?.fullName}
        onSave={handleSaveSignature}
      />
    </Box>
  );
}

DigitalSignature.propTypes = {
  addSignature: PropTypes.func,
  setFields: PropTypes.func,
};